import { ValuableNode } from '../../models/ValuableNode'

export class SchemaIterableNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Iterable': SchemaIterableNode
  }
}
